import { useState, useCallback } from 'react';
import { isChatSoundEnabled, setChatSoundEnabled } from '../utils/notification-sound';

/** Mute/unmute state for the chat notification sound, kept in localStorage */
export function useChatSoundPreference() {
  const [enabled, setEnabled] = useState(isChatSoundEnabled);

  const toggle = useCallback(() => {
    setEnabled(prev => {
      const next = !prev;
      setChatSoundEnabled(next);
      return next;
    });
  }, []);

  return { enabled, toggle };
}
